import { isSugarDaddyTheme as isSDT } from "@/service/general";

export default {
    data() {
        return {
            theme: process.env.VUE_APP_THEME
        }
    },
    methods: {
        termsLabel(fallbackKey = 'navigation.footer.terms') {
            if (this.theme !== 'luxliebe') return this.$t(fallbackKey);

            return this.$t(fallbackKey === 'signup.terms_of_service'
                ? 'terms.luxliebe.signup_label'
                : 'terms.luxliebe.label');
        },

        themeT(key, values) {
            const themedKey = `${key}.${this.theme}`;
            const translated = this.$t(themedKey, values);

            return translated === themedKey ? this.$t(key, values) : translated;
        },

        isSugarDaddyTheme() {
          return isSDT()
        }
    }
}
